// extracted by mini-css-extract-plugin
export default {"widgetButtonsWrapper":"WidgetButtonsWrapper_widgetButtonsWrapper__+qGlS"};